module.exports = __webpack_public_path__ + "img/call-record.2e65a32e.png";